import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-49bf3033"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "navbar",
  class: "navbar navbar-expand-lg bg-white sticky-top"
}
const _hoisted_2 = { class: "container-lg" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Magneto Renewable Energy logo",
  class: "img-fluid"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#Nav",
  "aria-controls": "Nav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  class: "collapse navbar-collapse justify-content-end",
  id: "Nav"
}
const _hoisted_6 = { class: "navbar-nav my-3 my-lg-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "d-block d-lg-none" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand",
        to: {name: 'Home'},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTop()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#About",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.scrollTop('#About')), ["prevent"]))
          }, "About"),
          _hoisted_7,
          _createElementVNode("a", {
            class: "nav-link",
            href: "#Solutions",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.scrollTop('#Solutions')), ["prevent"]))
          }, "Solutions"),
          _hoisted_8,
          _createElementVNode("a", {
            class: "nav-link",
            href: "#Projects",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.scrollTop('#Projects')), ["prevent"]))
          }, "Projects"),
          _hoisted_9,
          _createElementVNode("a", {
            class: "nav-link",
            href: "#Partners",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.scrollTop('#Partners')), ["prevent"]))
          }, "Partnerships"),
          _hoisted_10,
          _createVNode(_component_router_link, {
            class: "nav-link",
            to: {name: 'ResidentialHome'}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Residential")
            ]),
            _: 1
          }),
          _hoisted_11,
          _createElementVNode("a", {
            class: "nav-link",
            href: "mailto:info@magnetoenergy.co.za?subject=Enquiry%20from%20magnetoenergy.co.za",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeMenu()))
          }, " Contact Us "),
          _hoisted_12
        ])
      ])
    ])
  ]))
}